import { Skeleton } from "~/components/skeleton";

export default function DashboardLoading() {
	return (
		<div className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-4 p-4 pt-0">
			<div className="grid auto-rows-min gap-4 md:grid-cols-3">
				<Skeleton className="aspect-video" />
				<Skeleton className="aspect-video" />
				<Skeleton className="aspect-video" />
			</div>
			<Skeleton className="min-h-screen flex-1 md:min-h-min" />
		</div>
	);
}
